import React from "react";
import { differenceInCalendarDays, format, parseISO } from "date-fns";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  banner: {
    margin: theme.spacing(1, 2, 0),
  },
}));

const WARN_DAYS = 5;

// Aviso de vencimento para os administradores da empresa (a cobrança é
// feita fora do sistema; o bloqueio é manual pelo super admin)
const DueDateBanner = ({ user }) => {
  const classes = useStyles();
  const dueDate = user?.company?.dueDate;
  if (!dueDate || user.profile !== "admin") return null;

  const date = parseISO(dueDate);
  const days = differenceInCalendarDays(date, new Date());
  if (days > WARN_DAYS) return null;

  const params = {
    company: user.company.name,
    days,
    date: format(date, "dd/MM/yyyy"),
  };
  const key = days < 0 ? "overdue" : days === 0 ? "today" : "soon";

  return (
    <Alert severity={days < 0 ? "error" : "warning"} className={classes.banner}>
      {i18n.t(`dueBanner.${key}`, params)}
    </Alert>
  );
};

export default DueDateBanner;
